import { Text, Flash, BorderBox } from '@primer/components';
import { InfoIcon } from '@primer/styled-octicons';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  Text,
  Flash,
  BorderBox,
  InfoIcon,
  InlineCode,
  Link,
  React
};